export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.19-1918.58",
  commitId: "3fe900f2acd1d5685b23dbecdc49844ab9439a61",
  commitTime: "2026-10-19T19:18:58.000Z",
});
